import { render, staticRenderFns } from "./WeldingBucket.vue?vue&type=template&id=452c2e6f&scoped=true"
import script from "./WeldingBucket.vue?vue&type=script&lang=js"
export * from "./WeldingBucket.vue?vue&type=script&lang=js"
import style0 from "./WeldingBucket.vue?vue&type=style&index=0&id=452c2e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c2e6f",
  null
  
)

export default component.exports